import { LocalStorage } from 'shared/helpers/localStorage';
import { LOCAL_STORAGE_KEYS } from 'dashboard/constants/localStorage';
import MessageDraftAPI from 'dashboard/api/messageDraft';

const DRAFT_KEY_REGEX = /^draft-(\d+)-(reply|note)$/;

export default async function migrateDraftMessages() {
  const drafts = LocalStorage.get(LOCAL_STORAGE_KEYS.DRAFT_MESSAGES);
  if (!drafts || typeof drafts !== 'object') return;

  const entries = Object.entries(drafts);
  if (entries.length === 0) return;

  // Group by conversationId
  const grouped = {};
  entries.forEach(([key, value]) => {
    const match = key.match(DRAFT_KEY_REGEX);
    if (!match) return;

    const [, conversationId, replyType] = match;
    const message =
      typeof value === 'string' ? value : (value && value.message) || '';
    if (!message) return;

    if (!grouped[conversationId]) grouped[conversationId] = {};
    if (replyType === 'reply') {
      grouped[conversationId].publicContent = message;
    } else {
      grouped[conversationId].privateContent = message;
    }
  });

  const conversationIds = Object.keys(grouped);
  if (conversationIds.length === 0) {
    LocalStorage.remove(LOCAL_STORAGE_KEYS.DRAFT_MESSAGES);
    return;
  }

  await Promise.allSettled(
    conversationIds.map(id => MessageDraftAPI.update(id, grouped[id]))
  );

  LocalStorage.remove(LOCAL_STORAGE_KEYS.DRAFT_MESSAGES);
}
